import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
	type ApplicationConfig,
	inject,
	isDevMode,
	provideBrowserGlobalErrorListeners,
	provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import {
	nexpoEventScopeInterceptor,
	provideNexpoAgendaApi,
	provideNexpoApi,
	provideNexpoBoothApi,
	provideNexpoContentApi,
	provideNexpoEventScope,
	provideNexpoMapApi,
	provideNexpoProfileApi,
} from '@soft2code/nexpo-lib/api';
import { NexpoWorkspace, nexpoAuthInterceptor, provideNexpoAuth } from '@soft2code/nexpo-lib/core';
import { provideNexpoI18n } from '@soft2code/nexpo-lib/i18n';
import { provideNexpoMockData } from '@soft2code/nexpo-lib/mock';
import { provideNexpoTheme } from '@soft2code/nexpo-lib/theme';
import { provideNexpoStatusMap } from '@soft2code/nexpo-lib/ui';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { ADMIN_STATUS_MAP } from './core/status/status-map';

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideZonelessChangeDetection(),
		provideRouter(
			routes,
			withComponentInputBinding(),
			// A carga inicial encadeia redirects; sem isto a transição anterior é
			// abortada e o console reclama a cada abertura.
			withViewTransitions({ skipInitialTransition: true }),
			withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })
		),
		provideHttpClient(withFetch(), withInterceptors([nexpoAuthInterceptor, nexpoEventScopeInterceptor])),

		provideNexpoApi({ baseUrl: environment.apiUrl, application: 'NEXPO-ADMIN' }),
		provideNexpoAuth({ loginPath: '/sign-in', homePath: '/now' }),
		provideNexpoTheme({ defaultPreference: 'light', storageKey: 'nexpo_admin_theme' }),
		provideNexpoI18n({ storageKey: 'nexpo_admin_language' }),

		// A API escopa por feira (`x-event-id`). A fonte é a escolha do organizador,
		// lida a cada requisição: trocar de edição muda o escopo na hora.
		provideNexpoEventScope(() => inject(NexpoWorkspace).activeId()),

		// Só o que não tem rota roda em memória — hoje, o movimento da feira.
		...(environment.useMockData ? [provideNexpoMockData({ latencyMs: 280, anchorToday: true })] : []),
		// **Depois** do mock: os dois fornecem as mesmas portas, e o último vence.
		provideNexpoProfileApi(),
		provideNexpoContentApi(),
		provideNexpoAgendaApi(),
		provideNexpoMapApi(),
		provideNexpoBoothApi(),

		provideNexpoStatusMap(ADMIN_STATUS_MAP),

		// Circulando pelo pavilhão o wi-fi oscila: o service worker mantém a interface.
		provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000',
		}),
	],
};
